<script>
  import currentIdx from '../store/currentIdx';
  import fieldValues from '../store/fieldValues';
  import Form from '../components/Form.svelte';
  import SelectField from '../components/SelectField.svelte';
  import InputField from '../components/InputField.svelte';

  export let title;
  export let description;
</script>

<Form
  {title}
  {description}
  handlePrevious={currentIdx.decrementIndex}
  handleNext={currentIdx.incrementIndex}
  isDisabled={!$fieldValues['stack'] || !$fieldValues['language']}>
  <SelectField
    label="Stack"
    options={['Front', 'Back', 'FullStack']}
    value={$fieldValues['stack'] || ''}
    isRequired
    on:input={e => fieldValues.setField('stack', e.detail.value)} />
  <SelectField
    label="Language"
    options={['JavaScript', 'Python', 'Java', 'PHP', 'Other']}
    value={$fieldValues['language'] || ''}
    isRequired
    on:input={e => fieldValues.setField('language', e.detail.value)} />
  <InputField
    label="Other"
    placeholder="Go, Rust..."
    value={$fieldValues['other'] || ''}
    on:input={e => fieldValues.setField('other', e.detail.value)} />
</Form>
